import Text from "Components/shared/text";
import React from "react";
import { MyCard } from "./MyCard";
import { QuickTransfer } from "./QuickTransfer";

export const DashboardRight = ({transaction}) => {
  return (
    <Text tag="div" >
      <MyCard transaction={transaction}/>
      <QuickTransfer transaction={transaction}/>
    </Text>
  );
};
